import { render, staticRenderFns } from "./LimitFilter.vue?vue&type=template&id=47397332&"
import script from "./LimitFilter.vue?vue&type=script&lang=ts&"
export * from "./LimitFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports